module.exports = __webpack_public_path__ + "static/media/marek_wolfryd_rata.45f198dd.png";